import styled from "styled-components";

export const QueueManagerWrapperStyled = styled.div`
  height: calc(100% - 40px);
`;
